import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
  inject,
  DestroyRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ActivatedRoute,
  Router,
  RouterModule,
} from '@angular/router';
import { navItems } from '../sidebar/sidebar-data';
import { SharedModule } from 'src/app/shared/shared-module/shared';
import {
  LanguageEnum,
  Languages,
  TranslationService,
} from 'src/app/shared/services/translation.serive';
import { AccountService } from 'src/app/auth/data-access/account.service';
import {
  AlertData,
} from '../../notification-message/notification-message.component';
import { TranslocoService } from '@ngneat/transloco';
import { SharedService } from 'src/app/shared/services/shared.service';
import { SmsLinkService } from 'src/app/features/sms-link-legal/data-access/sms-link.service';

interface notifications {
  id: number;
  // img: string;
  title: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

@Component({
  selector: 'app-header',
  imports: [
    RouterModule,
    SharedModule,
  ],
  templateUrl: './header.component.html',
  standalone: true,
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  router = inject(Router);
  route = inject(ActivatedRoute);
  readonly translate = inject(TranslationService);
  readonly accountService = inject(AccountService);
  readonly transloco = inject(TranslocoService);
  readonly smsLinkService = inject(SmsLinkService);

  userDetails = this.accountService.accountState;

  constructor(
    public dialog: MatDialog
  ) { }

  pageName: string;
  isOpen: boolean = false
  navItems = navItems;
  @Input() mode: any;

  navItemsData = this.navItems.filter((navitem) => navitem.displayName);

  protected readonly translationService = inject(TranslationService);
  readonly sharedSergvice = inject(SharedService);

  langDisplaySymbol = this.translate.langDisplaySymbol;
  activeLangCodeState = this.translate.activeLangCodeState;
  languages = this.translate.availableLangState;
  screenTypeState = this.sharedSergvice.screenTypeState
  readonly loadedState = this.smsLinkService.loadedState;

  destroyRef = inject(DestroyRef);

  languageEnum = LanguageEnum
  changeLanguage(e: HTMLElement): void {
    if (e) { this.translate.setActiveLanguage(this.translate.transformSimbolToCode(e.innerText) as Languages) }
  }


  alertData: AlertData = {
    loading: true,
    messageTxt: `${this.transloco.translate(
      ''
    )} ${2} ${this.transloco.translate('')}`,
    redirectUrl: 'notifications/notification-list',
  };

  onNavView() {
    this.router.navigate(['notifications', 'notification-list']);
    this.alertData.loading = false;
  }

  onNotificationView() {
    this.alertData.loading = !this.alertData.loading;
  }


  onLogOut() {
    this.router.navigate(['']);
    this.accountService.logOut();
  }

  viewNotificationDetails(notification: notifications) {
    this.router.navigate([
      'notifications',
      'view-notification-list',
      notification.id,
    ]);
  }


  apps: apps[] = [
    {
      id: 2,
      img: '/assets/images/svgs/icon-dd-cart.svg',
      title: 'Todo App',
      subtitle: 'Completed task',
      link: '/apps/todo',
    },
  ];

  quicklinks: quicklinks[] = [
    {
      id: 1,
      title: 'Pricing Page',
      link: '/theme-pages/pricing',
    },
  ];

}
